<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-snackbar
      :color="color"
      :timeout="3000"
      top
      v-model="alert"
      >
        {{text}}
        <v-icon small color="white" @click="alert = false">mdi-close</v-icon>
      </v-snackbar>
    <v-card max-width="500" class="pa-6 rounded-xl elevation-3">

      <!-- Title -->
      <div class="text-h5 font-weight-bold mb-2">
        Change Password
      </div>

      <!-- Alert -->
      <v-alert type="warning" variant="tonal" class="mb-4">
        You must change your password before continuing.
      </v-alert>

      <!-- Form -->
      <v-form ref="form" v-model="validnForm" @submit.prevent="changePassword">
        <!-- Password -->
        <v-text-field
          v-model="password"
          label="password"
          outlined
          color="indigo"
          :rules="[rules.required]"
          :type="show ? 'text' : 'password'"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="show = !show"
          />

        <v-text-field
          v-model="confirmPassword"
          label="confirm password"
          outlined
          color="indigo"
          :rules="[rules.required, rules.simillar]"
          :type="showConfirm ? 'text' : 'password'"
          :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showConfirm = !showConfirm"
          />

        <!-- Submit -->
        <v-btn
          block
          color="indigo"
          class="white--text"
          :loading="loading"
          type="submit"
        >
          Update Password
        </v-btn>

      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { forceChangePassword, headers } from '../links'
export default {
  data () {
    return {
      show: false,
      loading: false,
      color: null,
      alert: false,
      text: null,
      validnForm: true,
      showConfirm: false,
      confirmPassword: null,
      password: null,
      rules: {
        required: value => !!value || 'this field is required',
        simillar: value => value === this.password || 'must be simillar'
      }
    }
  },
  methods: {
    changePassword () {
      this.$refs.form.validate()
      if (this.validnForm) {
        this.loading = true
        const body = {
          new_password: this.password,
          new_password_confirmation: this.confirmPassword
        }
        const token = localStorage.getItem('adamtravelToken')
        const header = { headers: headers(token) }
        this.$http.post(forceChangePassword, body, header)
          .then(response => {
            if (response.body.data) {
              this.$router.push({ name: 'login' })
              this.alert = true
              this.color = 'success'
              this.text = response.body.message
              localStorage.removeItem('adamtravelToken')
            } else {
              this.alert = true
              this.color = 'error'
              this.text = response.body.message
            }
          })
          .catch(err => {
            console.error(err)
            this.alert = true
            this.color = 'error'
            this.text = err.data ? err.data.message : err.message
          })
          .finally(() => {
            this.loading = false
          })
      }
    }

  }
}
</script>
